import React, { useCallback, useState, createContext, useContext } from 'react';
interface OrderBumpContextType {
  bump1: boolean;
  bump2: boolean;
  setBump1: (v: boolean) => void;
  setBump2: (v: boolean) => void;
  totalPrice: number;
  getCheckoutUrl: () => string;
  goToCheckout: () => void;
}
const OrderBumpContext = createContext<OrderBumpContextType | null>(null);
export function OrderBumpProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const totalPrice = 17 + (bump1 ? 7 : 0) + (bump2 ? 4 : 0);
  const getCheckoutUrl = useCallback(() => {
    if (bump1 && bump2) return 'https://www.gemmamama.com/cart/46426343342219:1';
    if (bump1) return 'https://www.gemmamama.com/cart/46426337214603:1';
    if (bump2) return 'https://www.gemmamama.com/cart/46426346487947:1';
    return 'https://www.gemmamama.com/cart/45389317111947:1';
  }, [bump1, bump2]);
  const goToCheckout = useCallback(() => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'The Nap-Trapped Reset',
        value: totalPrice,
        currency: 'USD'
      });
    }
    window.open(getCheckoutUrl(), '_blank');
  }, [totalPrice, getCheckoutUrl]);
  return <OrderBumpContext.Provider value={{
    bump1,
    bump2,
    setBump1,
    setBump2,
    totalPrice,
    getCheckoutUrl,
    goToCheckout
  }} data-id="element-822">
      {children}
    </OrderBumpContext.Provider>;
}
export function useOrderBumps() {
  const ctx = useContext(OrderBumpContext);
  if (!ctx) {
    throw new Error('useOrderBumps must be used within an OrderBumpProvider');
  }
  return ctx;
}
/** Safe version — returns null when used outside the provider instead of throwing */
export function useOrderBumpsSafe() {
  return useContext(OrderBumpContext);
}